import UnityLoader from "UnityLoader";
import * as common from "./common.js";
import * as facebook from "./facebook.js";
import * as ads from "./ads.js";

export const webViewPlugin = "pswebviewplugin";
export const webCommonPlugin = "pswebcommonplugin";
export const localStoragePlugin = "psweblocalstorageplugin";
const logsKey = "PS_LOGS";

let unityInstance;
const aspectRatio = 16.0 / 9.0;
let marginTop = 0;
let paddingBottom = 0;
const callbacksOnResize = [];
let ready = false;

export function init(buildUrl/*, startupCallback*/) {
    console.log("[w] UnityLoader instantiate");
    unityInstance = UnityLoader.instantiate("unityContainer", `${buildUrl}/${common.config.gameName}.json`, {onProgress: unityProgress});
}

// LOG and DEBUG -------------------- BEGIN

const enabledLogs = new Set();

export function disableAllLogCats() {
    enabledLogs.clear();
    writeLogCats();
}

export function enableLogCat(...logCat) {
    logCat.forEach(l => enabledLogs.add(l));
    writeLogCats();
}

export function disableLogCat(...logCat) {
    logCat.forEach(l => enabledLogs.delete(l));
    writeLogCats();
}

export function loadLogCats() {
    return new Promise(function (resolve) {
        const promise = common.readFromLocalStorage(logsKey);
        promise.then((logs) => {
            try {
                JSON.parse(logs).forEach((elem) => {
                    enabledLogs.add(elem);
                });
            } catch (e) {
                enabledLogs.clear();
            }
            resolve();
        });
    });
}

export function writeLogCats() {
    const logs = JSON.stringify(Array.from(enabledLogs));
    const promise = common.writeToLocalStorage(logsKey, logs);
    promise.then(() => {
        console.log("Logs has been changed");
        // Send logs back to unity
        sendLocalStorageValue(logsKey, logs);
    });
}

// LOG and DEBUG -------------------- END

export function sendData(plugin, data) {
    const gameObjectName = "PSPlugin";
    const gameObjectMethod = "OnDataReceive";
    const info = {
        "name": plugin,
        "data": JSON.stringify(data),
    };
    console.log("[w] sendData: ", plugin, "||", data);
    unityInstance.SendMessage(gameObjectName, gameObjectMethod, JSON.stringify(info));
}

export function sendError(plugin, code, data) {
    sendData(plugin, {
        "error": {
            "code": code,
            "message": data
        }
    });
}

export function mockedUnityStartup(callback) {
    console.log("[w] mocked startup");
    setTimeout(function () {
        callback({
            "Platform": {
                "launch": "whatever"
            }
        });
    }, 1000);
}


export function onUnityStartup() {
    console.log("[w] onUnityStartup");
    loadLogCats().then(() => {
        onStartupReady({
            "Platform":
                {
                    "launch":
                        {
                            "country": common.config.country,
                            "locale": common.config.locale,
                            "canvas_url": common.config.canvasUrl,
                            "game_url": common.config.webUrl,
                            // "platform": "html5",
                            //"environment": "demo",
                            "server_environment": common.config.environment,
                            // "game_name": "parchis",
                            "facebook":
                                {
                                    "app_id": "" + common.config.platformData.appId,
                                    "app_id_dev": "" + common.config.platformData.appId,
                                    "app_id_demo": "" + common.config.platformData.appId,
                                    "login_permissions": "public_profile,email,user_birthday,user_friends",
                                    // "api": "v2.6"
                                },
                            "logs": Array.from(enabledLogs)
                        }
                }
        });
    });

    window.onresize = function () {
        onResizeWindow();
    };
    onResizeWindow();
}

export function getCanvas() {
    return document.getElementById("#canvas");
}

function onResizeWindow() {
    common.getPageInfo(function (info) {
        const canvas = getCanvas();
        const container = document.getElementById("unityContainer");
        const footer = document.getElementsByTagName("footer")[0];
        const maxWidth = info.clientWidth;
        const maxHeight = info.clientHeight;
        const footerAdsHeight = ads.getFooterAdsHeigh();
        const offset = info.offsetTop + marginTop + (footer.clientHeight - footerAdsHeight) + paddingBottom;
        const newHeight = calculateCorrectHeight(maxWidth, maxHeight, offset);
        const newWidth = Math.floor(newHeight * aspectRatio);

        console.log("[w] page info", info);
        console.log("[w] new width: ", newWidth, " new height: ", newHeight);

        container.style.margin = "";
        container.style.marginTop = marginTop + "px";
        container.style.width = newWidth + "px";
        container.style.height = newHeight + "px";
        canvas.width = newWidth;
        canvas.height = newHeight;
        callbacksOnResize.forEach(c => c(info, canvas));
    });
}

export function onResize(callback) {
    callbacksOnResize.push(callback);
}

function calculateCorrectHeight(clientWidth, clientHeight, offset) {
    const availableHeight = clientHeight - offset;
    const widthFromCHeight = availableHeight * aspectRatio;
    const heightFromCHeight = widthFromCHeight / aspectRatio;
    const heightFromCWidth = clientWidth / aspectRatio;
    const widthFromCWidth = heightFromCWidth * aspectRatio;
    let newHeight;

    if (facebook.isCanvas()) {
        if (widthFromCHeight <= clientWidth && heightFromCHeight <= clientHeight) newHeight = heightFromCHeight;
        else newHeight = heightFromCWidth;
    } else {
        if (widthFromCWidth <= clientWidth && heightFromCWidth <= clientHeight) newHeight = heightFromCWidth;
        else newHeight = heightFromCHeight;
    }

    console.log("[w] Best h", newHeight);

    return Math.floor(newHeight);
}

function onStartupReady(data) {
    console.log("[w] startup ready :", JSON.stringify(data));
    ready = true;
    unityInstance.SendMessage("StartupScene", "SetStartupJson", JSON.stringify(data));
}

export function isReady() {
    return ready;
}

function getUnityCanvas() {
    return document.getElementsByTagName("canvas")[0];
}

export function onMouseOver(isOver, cursorType) {
    cursorType = isOver ? cursorType : -1;
    let cursor = "default";
    switch (cursorType) {
        case 0:
            cursor = "pointer";
            break;
        case 1:
            cursor = "text";
            break;
    }
    getUnityCanvas().style.cursor = cursor;
}

function unityProgress(unityInstance, progress) {
    if (!unityInstance.Module)
        return;

    if (!unityInstance.logo) {
        unityInstance.logo = document.createElement("div");
        unityInstance.logo.className = "logo " + unityInstance.Module.splashScreenStyle;
        unityInstance.container.appendChild(unityInstance.logo);
    }

    if (!unityInstance.progress) {
        unityInstance.progress = document.createElement("div");
        unityInstance.progress.className = "progress " + unityInstance.Module.splashScreenStyle;
        unityInstance.progress.empty = document.createElement("div");
        unityInstance.progress.empty.className = "empty";
        unityInstance.progress.appendChild(unityInstance.progress.empty);
        unityInstance.progress.full = document.createElement("div");
        unityInstance.progress.full.className = "full";
        unityInstance.progress.appendChild(unityInstance.progress.full);
        unityInstance.container.appendChild(unityInstance.progress);
    }

    unityInstance.progress.full.style.width = (100 * (1 - progress)) + "%";
    unityInstance.progress.empty.style.width = (100 * progress) + "%";

    if (progress === 1)
        unityInstance.logo.style.display = unityInstance.progress.style.display = "none";
}

const deviceIdKey = "PS_DEVICEID";
const idfaKey = "PS_IDFA";

export function requestDeviceId() {
    console.log("[w] req device id");
    const promise = common.readFromLocalStorage(deviceIdKey);
    promise.then((id) => {
        console.log("[w] device id: ", deviceIdKey, " - ", id);
        sendLocalStorageValue(deviceIdKey, id);
    });
}

export function requestIdfa() {
    console.log("[w] req device idfa");
    const promise = common.readFromLocalStorage(idfaKey);
    promise.then((id) => {
        console.log("[w] idfa: ", idfaKey, " - ", id);
        sendLocalStorageValue(idfaKey, id);
    });
}

function sendLocalStorageValue(k, v) {
    const dataJson = {
        key: k,
        value: v
    };
    sendData(localStoragePlugin, dataJson);
}

export function setDeviceId(newId) {
    const promise = common.writeToLocalStorage(deviceIdKey, newId);
    console.log("[w] set device id: ", deviceIdKey, " - ", newId);
    promise.then(() => {
        onLocalStorageValueSet(deviceIdKey, newId);
    });
}

export function setIdfa(newIdfa) {
    const promise = common.writeToLocalStorage(idfaKey, newIdfa);
    console.log("[w] set device idfa: ", idfaKey, " - ", newIdfa);
    promise.then(() => {
        onLocalStorageValueSet(idfaKey, newIdfa);
    });
}

function onLocalStorageValueSet(k, v) {
    console.log("local storage key: ", k, " set to: ", v);
}

export function mute() {
    console.error("not yet implemented");
}

export function unmute() {
    console.error("not yet implemented");
}

export {
    unityInstance,
};